<script>
  import { GroupsRepository } from "../repositories/index";
  import {
    Button,
    Buttons,
    Form,
    FormTheme,
    Submit,
    TextField,
    Modal,
  } from "@gl/design-system";
  import { createEventDispatcher, onMount, setContext } from "svelte";
  import { ModalType } from "../types/modal";
  import {
    isValidDescription,
    isValidNameWithoutSpace,
  } from "../utils/validators";
  import { _, callout } from "../stores/index";

  export let data;
  export let modalType;
  export let active;

  setContext("FormTheme", FormTheme);

  const dispatch = createEventDispatcher();
  const loading = {};

  const form = {
    description: "",
    name: "",
  };

  async function onSubmit() {
    loading.submit = true;

    try {
      const result =
        modalType === ModalType.Put
          ? await GroupsRepository.editGroup(data.id, {
              description: form.description,
            })
          : await GroupsRepository.addGroup(form);

      if (result === "") {
        callout.set({
          msg: $_("common.nochanges"),
          status: "warning",
          timeout: true,
        });
        dispatch("close");
      } else {
        dispatch("success");
        dispatch("close");
      }
    } finally {
      loading.submit = false;
    }
  }

  onMount(() => {
    if (data) {
      form.name = data.name;
      form.description = data.description;
    }
  });
</script>

<Modal bind:active on:close boxed>
  <div class="gl-title mb-4">
    {modalType === ModalType.Put
      ? $_("groups.edit_group")
      : $_("groups.add_group")}
  </div>
  <Form validationMode="eager">
    <TextField
      bind:value={form.name}
      id="group-label"
      label={$_("common.name")}
      required={$_("validations.required")}
      disabled={modalType === ModalType.Put}
      validate={(value) => isValidNameWithoutSpace(value)}
      maxLength={35}
      config={{ characterCount: $_("character.count") }}
    />

    <TextField
      bind:value={form.description}
      id="group-description"
      label={$_("common.description")}
      validate={(value) => isValidDescription(value)}
      maxLength={150}
      config={{ characterCount: $_("character.count") }}
    />

    <Buttons class="mt-6">
      <Submit
        on:submit={onSubmit}
        loading={loading.submit}
        label={$_("buttons.save")}
      />
      <Button outlined on:click={() => dispatch("close")}
        >{$_("buttons.cancel")}</Button
      >
    </Buttons>
  </Form>
</Modal>
